<mat-checkbox
  class="cellcheckbox custom-mat-checkbox mat-elevation-z0"
  [checked]="checked"
  (change)="checkChanged($event)"
></mat-checkbox>
